module.exports = __webpack_public_path__ + "img/fd_240.77910ffd.png";